import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsStarlingbankComponent } from './simple-icons-starlingbank.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsStarlingbankComponent ],
    exports:      [ SimpleIconsStarlingbankComponent ],
    bootstrap:    []
})
export class SimpleIconsStarlingbankModule {}
